import { StoreState } from '@/core/models/store.interface';
import { Module } from 'vuex';
import { CalculatedFieldConditionType } from './calculated-field-condition-type.interface';
import { CalculatedFieldConditionTypeService } from './calculated-field-condition-type.service';

const service = new CalculatedFieldConditionTypeService();

export interface CalculatedFieldConditionTypeState {
   calculatedFieldConditionTypes: Array<CalculatedFieldConditionType>;
}

const CalculatedFieldConditionTypeStore: Module<CalculatedFieldConditionTypeState, StoreState> = {
   namespaced: true,
   state: {
      calculatedFieldConditionTypes: [],
   },
   getters: {},
   mutations: {
      SET_CALCULATED_FIELD_CONDITION_TYPES(state, calculatedFieldConditionTypes: Array<CalculatedFieldConditionType>) {
         state.calculatedFieldConditionTypes = calculatedFieldConditionTypes;
      },
   },
   actions: {
      async getCalculatedFieldConditionTypes(context) {
         const response = await service.getCalculatedFieldConditionTypes();
         context.commit('SET_CALCULATED_FIELD_CONDITION_TYPES', response.data);
         return response.data;
      },
   },
};

export default CalculatedFieldConditionTypeStore;
